import { Box, Container, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';

// Styled components
const StyledFooter = styled(Box)<{ $isDarkMode: boolean }>(({ theme, $isDarkMode }) => ({
  padding: theme.spacing(4, 0),
  marginTop: 'auto',
  backgroundColor: $isDarkMode ? theme.palette.background.paper : '#f5f5f5',
  borderTop: `1px solid ${theme.palette.divider}`,
}));

const StyledContainer = styled(Container)(({ theme }) => ({
  maxWidth: 'lg',
}));

const StyledFooterContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}));

const StyledCopyright = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    marginBottom: 0,
  },
}));

const StyledLinksContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  alignItems: 'center',
}));

const StyledFooterLink = styled(RouterLink)(({ theme }) => ({
  color: 'inherit',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

const StyledSocialLink = styled('a')(({ theme }) => ({
  color: theme.palette.text.secondary,
  padding: theme.spacing(0.5, 1),
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  textDecoration: 'none',
  transition: 'all 0.2s ease',
  borderRadius: theme.spacing(1),
  lineHeight: 1,
  '&:hover': {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.action.hover,
  },
}));

export const Footer: React.FC = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  
  return (
    <StyledFooter component="footer" $isDarkMode={isDarkMode}>
      <StyledContainer>
        <StyledFooterContent>
          <StyledCopyright variant="body2">
            © {new Date().getFullYear()} Pippaya. Alle rechten voorbehouden.
          </StyledCopyright>

          <StyledSocialLink
              href="https://www.facebook.com/Pippaya.Hondenopvang"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Bezoek onze Facebook pagina"
            >
              <FacebookIcon fontSize="small" />
              <Typography 
                variant="body2" 
                component="span"
                sx={{ lineHeight: 1 }}
              >
                Volg ons op Facebook
              </Typography>
            </StyledSocialLink>
          
          <StyledLinksContainer>
            <StyledFooterLink to="/privacy">
              Privacyverklaring
            </StyledFooterLink>

            <StyledFooterLink to="/algemene-voorwaarden">
              Algemene Voorwaarden
            </StyledFooterLink>
          </StyledLinksContainer>
        </StyledFooterContent>
      </StyledContainer>
    </StyledFooter>
  );
}; 

export default Footer;